import React, { Component } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { API_WEB_URLS } from "../../constants/constAPI";
import {
  Fn_AddEditData,
  Fn_DeleteData,
  Fn_FillListData,
  Fn_GetReport,
} from "../../store/functions";
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import SheetSizingGrid from "./SheetSizingGrid";

const today = new Date().toISOString().split("T")[0];
const initialSheetRows = [
  {
    OrderDate: today,
    DOD2: today,
    CodeNo: "",
    F_UnitSize: 3,
    F_UnitType: 0,
    F_PlyMaster: 0,
    PlyMargin: "",
    Length: 0,
    LengthMar: "",
    Width: 0,
    WidthMar: "",
    Height: 0,
    HeightMar: "",
    LengthManual: 0,
    LengthManualMargin: "",
    WidthManual: 0,
    WidthManualMargin: "",
    HeightManual: 0,
    HeightManualMargin: "",
    Pinning: 0,
    PinningMargin: "",
    F_TypeMaster: 0,
    InOut: 0,
    F_CalculationTypeMaster: 0,
    NoOfBox: 0,
    SPDP: 0,
    TLength: 0,
    TLengthMargin: "",
    LengthIncre: 1,
    LengthIncrement: 0.5,
    BlankIncre: 0,
    THeight: 0,
    THeightMargin: "",
    HeightIncre: 1,
    TWidth: 0,
    TWidthMargin: "",
    WidthIncre: 1,
    LengthX: "",
    X: "X",
    HeightX: "",
    WidthX: "",
    ShortQty: 0,
    IsCompleted: false,
    IsPaste: false,
    IsPrint: false,
    F_PrintDescriptionMaster: 0,
    PlyMarginDec: 0,
    LengthMarDec: 0,
    WidthMarDec: 0,
    HeightMarDec: 0,
    PinningMarginDec: 0,
    LengthMarginDec: 0,
    HeightMarginDec: 0,
    WidthMarginDec: 0,
    HalfWidth: 0,
    HalfWidthMar: "",
    HalfWidthMarDec: 0,
    F_ItemTypeMaster: 0,
    LengthXDec: 0,
    HeightXDec: 0,
    WidthXDec: 0,
  },
];

class AddSheetSizing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      F_UnitSize: 3,
      showCalc: false,
      voucherDropdown: "",
      OrderDate: today,
      DOD2: today,
      CodeNo: "",
      F_UnitSize: 3,
      F_UnitType: 0,
      F_PlyMaster: 0,
      PlyMargin: "",
      Length: 0,
      LengthMar: "",
      Width: 0,
      WidthMar: "",
      Height: 0,
      HeightMar: "",
      LengthManual: 0,
      LengthManualMargin: "",
      WidthManual: 0,
      WidthManualMargin: "",
      HeightManual: 0,
      HeightManualMargin: "",
      Pinning: 0,
      PinningMargin: "",
      F_TypeMaster: 0,
      InOut: 0,
      F_CalculationTypeMaster: 0,
      NoOfBox: 0,
      SPDP: 0,
      TLength: 0,
      TLengthMargin: "",
      LengthIncre: 1,
      LengthIncrement: 0.5,
      BlankIncre: 0,
      THeight: 0,
      THeightMargin: "",
      HeightIncre: 1,
      TWidth: 0,
      TWidthMargin: "",
      WidthIncre: 1,
      LengthX: "",
      X: "X",
      HeightX: "",
      WidthX: "",
      ShortQty: 0,
      IsCompleted: false,
      IsPaste: false,
      IsPrint: false,
      F_PrintDescriptionMaster: 0,
      PlyMarginDec: 0,
      LengthMarDec: 0,
      WidthMarDec: 0,
      HeightMarDec: 0,
      PinningMarginDec: 0,
      LengthMarginDec: 0,
      HeightMarginDec: 0,
      WidthMarginDec: 0,
      HalfWidth: 0,
      HalfWidthMar: "",
      HalfWidthMarDec: 0,
      F_ItemTypeMaster: 0,
      LengthXDec: 0,
      HeightXDec: 0,
      WidthXDec: 0,
      F_VoucherNo: "",
      voucherDate: "",
      OrderId: "",
      OrderNo: "",
      DOD: "",
      OrderDate2: "",
      F_LedgerMaster: 0,
      Name: "",
      UnitName: "",
      sheetRows: initialSheetRows,
      selectedRowIndex: 0,
      TotalQty: 0,
      isOrderSelected: false,
      SheetSizingDetail: [],
      LedgerMaster: [],
      GlobalOptions: [],
      OrderArr: [],
      VoucherNoNew: [],
      YearMaster: [],
      MonthMaster: [],
      CalculationTypeMaster: [],
      UnitSize: [],
      VoucherNo: [],
      TypeMaster: [],
      PaperTypeMaster: [],
      Ply: [],
      PrintDescription: [],
      ConverttoSoot: [],
    };

    this.obj = this;
    this.API_URL_SAVEL = API_WEB_URLS.SheetSizingH + "/0/token";
    this.API_URL_SAVE = API_WEB_URLS.SheetSizingL + "/0/token";
    //this.API_URL_GETJobCard = API_WEB_URLS.GetJobcard_Sheetsizing + "/0/token";
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeVoucherNo = this.handleChangeVoucherNo.bind(this);

    // Create refs for form inputs
    this.voucherNoRef = React.createRef();
    this.voucherDateRef = React.createRef();
    this.ledgerRef = React.createRef();
    this.orderNoRef = React.createRef();
    this.unitNameRef = React.createRef();
    this.dodRef = React.createRef();
    this.orderDateRef = React.createRef();
    this.sheetSizingGridRef = React.createRef();
  }

  async componentDidMount() {
    const today = new Date().toISOString().split("T")[0];
    this.setState({
      voucherDate: today,
      OrderDate: today,
      DOD: today,
      OrderDate2: today,
      DOD2: today,
    });

    //Filling DropDowns
    Fn_FillListData(
      this.obj,
      "LedgerMaster",
      API_WEB_URLS.MASTER + "/0/token/LedgerMasterr/Id/0"
    );
    Fn_FillListData(
      this.obj,
      "GlobalOptions",
      API_WEB_URLS.MASTER + "/0/token/GlobalOptions/Id/0"
    );
    Fn_FillListData(
      this.obj,
      "OrderArr",
      API_WEB_URLS.MASTER + "/0/token/OrderDetailH/Id/0"
    );

    const res = await Fn_FillListData(
      this.obj,
      "VoucherNoNew",
      API_WEB_URLS.MASTER + "/0/token/VoucherNoNew/Id/0"
    );
    console.log("res", res);
    if (res && res.length > 0 && res[0].VoucherNoNew) {
      const voucherNo = res[0].VoucherNoNew;
      console.log("voucherNo", voucherNo);
      this.setState({ F_VoucherNo: voucherNo });
    }
    // Add YearMaster and MonthMaster API calls
    Fn_FillListData(
      this.obj,
      "YearMaster",
      API_WEB_URLS.MASTER + "/0/token/YearMaster/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "MonthMaster",
      API_WEB_URLS.MASTER + "/0/token/MonthMaster/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "CalculationTypeMaster",
      API_WEB_URLS.MASTER + "/0/token/CalculationTypeMaster/Id/0"
    );


    Fn_FillListData(
      this.obj,
      "UnitSize",
      API_WEB_URLS.MASTER + "/0/token/UnitSize/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "VoucherNo",
      API_WEB_URLS.MASTER + "/0/token/VoucherNo/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "TypeMaster",
      API_WEB_URLS.MASTER + "/0/token/TypeMaster/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "PaperTypeMaster",
      API_WEB_URLS.MASTER + "/0/token/PaperTypeMaster/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "SootMaster",
      API_WEB_URLS.MASTER + "/0/token/SootMaster/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "ItemTypeMaster",
      API_WEB_URLS.MASTER + "/0/token/ItemTypeMaster/Id/0"
    );
  }

  getMonthYearMasterFromDate = inputDate => {
    console.log("inputDate", inputDate);
    const date = new Date(inputDate);

    const monthNumber = date.getMonth() + 1; // 1 to 12
    const yearString = date.getFullYear().toString();

    const { YearMaster, MonthMaster } = this.state;

    console.log("YearMaster", YearMaster);
    console.log("MonthMaster", MonthMaster);
    console.log("Looking for year:", yearString);

    const yearMatch =
      YearMaster && YearMaster.find(item => item.Name === yearString);
    const F_YearMaster = yearMatch ? yearMatch.Id : -1;

    const monthName = date
      .toLocaleString("default", { month: "long" })
      .toLowerCase();
    console.log("Looking for month:", monthName);

    const monthMatch =
      MonthMaster &&
      MonthMaster.find(item => item.Name.toLowerCase() === monthName);
    const F_MonthMaster = monthMatch ? monthMatch.Id : -1;

    console.log("Found F_YearMaster:", F_YearMaster);
    console.log("Found F_MonthMaster:", F_MonthMaster);

    return { F_MonthMaster, F_YearMaster };
  };

  delete = async () => {
    console.log("this.state.voucherNo", this.state.voucherNo);
    if (this.state.voucherNo) {
      await Fn_DeleteData(
        this.obj,
        this.state.voucherNo,
        "Masters/0/token/SheetSizingH",
        "Masters/0/token/VoucherNo" + "/Id/0"
      );

      this.handleAdd();
    }
  };

  add = () => {};

  handleAdd = async () => {
    const today = new Date().toISOString().split("T")[0];

    // Reset all form state
    this.setState({
      F_UnitSize: 3,
      showCalc: false,
      voucherDropdown: "",
      OrderDate: today,
      DOD2: today,
      CodeNo: "",
      F_UnitType: 0,
      F_PlyMaster: 0,
      PlyMargin: "",
      Length: 0,
      LengthMar: "",
      Width: 0,
      WidthMar: "",
      Height: 0,
      HeightMar: "",
      LengthManual: 0,
      LengthManualMargin: "",
      WidthManual: 0,
      WidthManualMargin: "",
      HeightManual: 0,
      HeightManualMargin: "",
      Pinning: 0,
      PinningMargin: "",
      F_TypeMaster: 0,
      InOut: 0,
      F_CalculationTypeMaster: 0,
      NoOfBox: 0,
      SPDP: 0,
      TLength: 0,
      TLengthMargin: "",
      LengthIncre: 1,
      LengthIncrement: 0.5,
      BlankIncre: 0,
      THeight: 0,
      THeightMargin: "",
      HeightIncre: 1,
      TWidth: 0,
      TWidthMargin: "",
      WidthIncre: 1,
      LengthX: "",
      HeightX: "",
      WidthX: "",
      ShortQty: 0,
      IsCompleted: false,
      IsPaste: false,
      IsPrint: false,
      F_PrintDescriptionMaster: 0,
      PlyMarginDec: 0,
      LengthMarDec: 0,
      WidthMarDec: 0,
      HeightMarDec: 0,
      PinningMarginDec: 0,
      LengthMarginDec: 0,
      HeightMarginDec: 0,
      WidthMarginDec: 0,
      HalfWidth: 0,
      HalfWidthMar: "",
      HalfWidthMarDec: 0,
      F_ItemTypeMaster: 1,
      LengthXDec: 0,
      HeightXDec: 0,
      WidthXDec: 0,
      selectedRowIndex: null,
      sheetRows: initialSheetRows,
      TotalQty: 0,
      UnitName: "",
      voucherNo: "",
      OrderNo: "",
      PONo: "",
      DOD: today,
      OrderDate2: today,
      voucherDate: today,
      F_LedgerMaster: 0,
      SheetSizingDetail: [],
      F_SheetSizingMasterH: 0,
      F_VoucherNo: "",
    });

    // Focus on VoucherNo field after reset
    Fn_FillListData(
      this.obj,
      "VoucherNo",
      API_WEB_URLS.MASTER + "/0/token/VoucherNo/Id/0"
    );

    const res = await Fn_FillListData(
      this.obj,
      "VoucherNoNew",
      API_WEB_URLS.MASTER + "/0/token/VoucherNoNew/Id/0"
    );
    console.log("res", res);
    if (res && res.length > 0 && res[0].VoucherNoNew) {
      const voucherNo = res[0].VoucherNoNew;
      console.log("voucherNo", voucherNo);
      this.setState({ F_VoucherNo: voucherNo });
    }
    setTimeout(() => {
      if (this.voucherNoRef && this.voucherNoRef.current) {
        this.voucherNoRef.current.focus();
      }
    }, 100);
  };

  // Handle keyboard navigation for form inputs
  handleKeyDown = (e, currentField) => {
    if (e.key === "Enter") {
      e.preventDefault();

      // Define the navigation sequence
      const navigationSequence = [
        "voucherNo",
        "voucherDate",
        "ledger",
        "orderNo",
        "dod",
        "orderDate",
        "unitName",
      ];

      const currentIndex = navigationSequence.indexOf(currentField);
      const nextIndex = currentIndex + 1;

      // Move to next field if it exists
      if (nextIndex < navigationSequence.length) {
        const nextField = navigationSequence[nextIndex];

        switch (nextField) {
          case "voucherNo":
            this.voucherNoRef.current?.focus();
            break;
          case "voucherDate":
            this.voucherDateRef.current?.focus();
            break;
          case "ledger":
            this.ledgerRef.current?.focus();
            break;
          case "orderNo":
            this.orderNoRef.current?.focus();
            break;
          case "unitName":
            this.unitNameRef.current?.focus();
            break;
          case "dod":
            this.dodRef.current?.focus();
            break;
          case "orderDate":
            this.orderDateRef.current?.focus();
            break;
        }
      } else if (currentField === "unitName") {
        // After unitName, focus on the first row's orderDate in the grid
        console.log("UnitName field - Enter pressed, trying to focus on grid OrderDate");
        
        // Function to attempt focusing on OrderDate
        const attemptFocus = (attempt = 1, maxAttempts = 3) => {
          if (this.sheetSizingGridRef.current && this.state.sheetRows.length > 0) {
            // Access the grid's input refs and focus on first row's orderDate
            const gridInputRefs = this.sheetSizingGridRef.current.inputRefs?.current;
            console.log(`Attempt ${attempt}: Grid refs:`, gridInputRefs);
            
            if (gridInputRefs && gridInputRefs[0] && gridInputRefs[0]['OrderDate']) {
              console.log("Focusing on first row OrderDate");
              gridInputRefs[0]['OrderDate'].focus();
              return true;
            } else {
              console.log(`Attempt ${attempt}: Could not find OrderDate input ref, trying fallback method`);
              // Fallback: try to find the first OrderDate input in the grid table
              const gridTable = document.querySelector('table');
              if (gridTable) {
                const firstOrderDateInput = gridTable.querySelector('input[type="date"]');
                if (firstOrderDateInput) {
                  console.log("Found OrderDate input via fallback method");
                  firstOrderDateInput.focus();
                  return true;
                } else {
                  console.log(`Attempt ${attempt}: Could not find OrderDate input via fallback method`);
                }
              } else {
                console.log(`Attempt ${attempt}: Could not find grid table`);
              }
            }
          } else {
            console.log(`Attempt ${attempt}: Grid ref or sheetRows not available`);
            console.log("SheetRows length:", this.state.sheetRows?.length);
            console.log("Grid ref:", this.sheetSizingGridRef.current);
          }
          
          // Retry with exponential backoff if we haven't reached max attempts
          if (attempt < maxAttempts) {
            const delay = 200 * Math.pow(2, attempt - 1); // 200ms, 400ms, 800ms
            console.log(`Retrying in ${delay}ms...`);
            setTimeout(() => attemptFocus(attempt + 1, maxAttempts), delay);
          }
          
          return false;
        };
        
        // Start the focus attempt with initial delay
        setTimeout(() => attemptFocus(), 200);
      }
    }
  };
  handleChangeOrderNo = async e => {
    const selectedOrderId = e.target.value;
    this.setState({
      OrderId: selectedOrderId,
      isOrderSelected: !!selectedOrderId,
    });

    if (!selectedOrderId) {
      this.setState({
        OrderNo: "",
        DOD: "",
        OrderDate2: "",
        F_LedgerMaster: 0,
        Name: "",
        sheetRows: initialSheetRows,
        TotalQty: 0,
      });
      return;
    }

    const res = await Fn_DisplayData(
      this.obj,
      selectedOrderId,
      this.API_URL + "/Id"
    );
    console.log(res);
    const res1 = await Fn_FillListData(
      this.obj,
      "TestArr",
      API_WEB_URLS.MASTER + "/0/token/OrderDetailL/Id/" + selectedOrderId
    );
    console.log(res1);
    // Optionally call API to load dependent data
    const { F_YearMaster, F_MonthMaster } = this.getMonthYearMasterFromDate(
      res.OrderDate2
    );
    const vformData = new FormData();
    vformData.append("F_LedgerMaster", res.F_LedgerMaster);
    vformData.append("F_YearMaster", F_YearMaster);
    vformData.append("F_MonthMaster", F_MonthMaster);

    await Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: vformData } },
      "GetPlyPartyDescriptionRates/0/token",
      "Ply",
      true
    );
    await Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: vformData } },
      "GetPrintPartyDescriptionRates/0/token",
      "PrintDescription",
      true
    );
    // Set form data from res
    this.setState({
      OrderNo: res.OrderNo || "",
      DOD: res.DOD ? res.DOD.split("T")[0] : "",
      OrderDate2: res.OrderDate2 ? res.OrderDate2.split("T")[0] : "",
      F_LedgerMaster: res.F_LedgerMaster || 0,
      Name: res.Name || "",
    });

    // Set sheet rows from res1
    if (res1 && res1.length > 0) {
      const sheetRows = res1.map(item => ({
        ...this.state.sheetRows[0], // Keep default values
        F_OrderDetailL: item.Id || 0,
        CodeNo: item.CodeNo || "",
        F_PlyMaster: item.F_PlyMaster || 0,
        PlyMargin: item.PlyMargin || "",
        Length: item.Length || 0,
        LengthMar: item.LengthMar || "",
        Width: item.Width || 0,
        WidthMar: item.WidthMar || "",
        Height: item.Height || 0,
        HeightMar: item.HeightMar || "",
        LengthManual: item.Length || "",
        LengthManualMargin: item.LengthMar || "",
        WidthManual: item.Width || "",
        WidthManualMargin: item.WidthMar || "",
        HeightManual: item.Height || "",
        HeightManualMargin: item.HeightMar || "",
        F_TypeMaster: item.F_TypeMaster || 0,
        InOut: item.InOut || 0,
        F_CalculationTypeMaster: item.F_CalculationTypeMaster || 0,
        NoOfBox: item.NoOfBox || 0,
        F_UnitSize: item.F_UnitSize || 3,
        F_ItemType: item.F_ItemType || 1,
        OrderDate: res.OrderDate2 ? res.OrderDate2.split("T")[0] : "",
        DOD2: res.DOD ? res.DOD.split("T")[0] : "",
        F_PrintDescriptionMaster: item.PrintDesc ? item.PrintDesc : 0 ,
      }));
      console.log("sheetRows", sheetRows);
      // Calculate box size for each row
      const calculatedRows = sheetRows.map(row => this.CalculateBoxSize(row));

      this.setState({
        sheetRows: calculatedRows,
        TotalQty: calculatedRows.reduce(
          (sum, row) => sum + (parseFloat(row.NoOfBox) || 0),
          0
        ),
      });
    }

    // Focus on VoucherNo field after order selection
    setTimeout(() => {
      if (this.voucherNoRef && this.voucherNoRef.current) {
        this.voucherNoRef.current.focus();
      }
    }, 100);
  };
  handleChangeVoucherNo = async e => {
    let id = 0;
    const selectedVoucherId = e.target.value; // Get the selected voucher ID
    console.log("selectedVoucherId", selectedVoucherId);
    // Store the selected voucher ID in state
    this.setState({ voucherNo: selectedVoucherId });

    const response = await Fn_FillListData(
      this.obj,
      "SheetSizingDetail",
      API_WEB_URLS.MASTER + "/0/token/VoucherNo/Id/" + selectedVoucherId
    );
    console.log("response", response);
    
    // Use first object from response array to set values
    if (response && response.length > 0) {
      const firstObject = response[0];
      this.setState({
        F_LedgerMaster: firstObject.F_LedgerMaster || 0,
        Name: firstObject.Name || "",
        OrderNo: firstObject.OrderNo || "",
        DOD: firstObject.DOD ? firstObject.DOD.split("T")[0] : "",
        OrderDate2: firstObject.OrderDate2 ? firstObject.OrderDate2.split("T")[0] : "",
        voucherDate: firstObject.voucherDate ? firstObject.voucherDate.split("T")[0] : "",
        TotalQty: firstObject.TotalQty || 0,
        F_VoucherNo: firstObject.F_VoucherNo || "",
        UnitName: firstObject.UnitName || "",
        OrderId: firstObject.F_OrderDetailH || 0
      });
    }
    
    
    const { F_YearMaster, F_MonthMaster } = this.getMonthYearMasterFromDate(
      this.state.voucherDate || this.state.OrderDate
    );
    const vformData = new FormData();
    vformData.append("F_LedgerMaster", response[0]?.F_LedgerMaster);
    vformData.append("F_YearMaster", F_YearMaster);
    vformData.append("F_MonthMaster", F_MonthMaster);

    Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: vformData } },
      "GetPlyPartyDescriptionRates/0/token",
      "Ply",
      true
    );
    Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: vformData } },
      "GetPrintPartyDescriptionRates/0/token",
      "PrintDescription",
      true
    );
    const response2 = await Fn_FillListData(
      this.obj,
      "sheetRows",
      API_WEB_URLS.MASTER +
        "/0/token/SheetSizingLByVoucherNo/Id/" +
        selectedVoucherId
    );
    console.log("response2", response2);
    id =
      this.state.sheetRows.length > 0
        ? this.state.sheetRows[0].F_SheetSizingMasterH
        : 0;
    this.setState({ F_SheetSizingMasterH: id });
  };

  handleChange = async e => {
    const { name, value } = e.target;

    if (name === "F_VoucherNo") {
      const selectedVoucher = this.state.VoucherNo.find(
        v => v.Id.toString() === value
      );
      this.setState({
        [name]: value,
        voucherNo: selectedVoucher ? selectedVoucher.Id : "",
        voucherDate: selectedVoucher
          ? selectedVoucher.Date || this.state.voucherDate
          : "",
      });
    } else if (name === "DOD") {
      const today = new Date().toISOString().split("T")[0];
      this.setState({ DOD: today });
    } else if (name === "OrderDate2") {
      const today = new Date().toISOString().split("T")[0];
      this.setState({ OrderDate2: today });
    } else if (name === "F_LedgerMaster") {
      this.setState({ F_LedgerMaster: value });

      // Optionally call API to load dependent data
      const { F_YearMaster, F_MonthMaster } = this.getMonthYearMasterFromDate(
        this.state.voucherDate || this.state.OrderDate
      );
      const vformData = new FormData();
      vformData.append("F_LedgerMaster", value);
      vformData.append("F_YearMaster", F_YearMaster);
      vformData.append("F_MonthMaster", F_MonthMaster);

      Fn_GetReport(
        this.obj,
        { arguList: { id: 0, formData: vformData } },
        "GetPlyPartyDescriptionRates/0/token",
        "Ply",
        true
      );
      Fn_GetReport(
        this.obj,
        { arguList: { id: 0, formData: vformData } },
        "GetPrintPartyDescriptionRates/0/token",
        "PrintDescription",
        true
      );
    } else {
      if (["TLength", "THeight"].includes(name)) {
        const minValue = this.state[name + "Min"] || 0;
        const maxValue = this.state[name + "Max"] || 0;
        const gapValue = this.state[name + "Gap"] || 2;

        const calculatedValue = this.MinMaxCalculation(
          value,
          minValue,
          maxValue,
          gapValue
        );
        this.setState({ [name]: calculatedValue });
      } else {
        this.setState({ [name]: value });
      }
    }
  };

  handleCalcLengthBySPDP = row => {
    let LengthX = 0.0;
    let StrLengthX = 0.0;
    let StrLengthXMargin = "";

    const dpsp = parseInt(row.SPDP || 0);

    // Get basic measurements
    const length = parseFloat(row.Length || 0);
    const width = parseFloat(row.Width || 0);
    const PinningFleb = parseFloat(row.Pinning || 0);

    // Get decimal values
    const lengthDecVal = this.ConverttoDecimal(row.LengthMar || 0);
    const widthDecVal = this.ConverttoDecimal(row.WidthMar || 0);
    const PinningFlebDecVal = this.ConverttoDecimal(row.PinningMargin || 0);

    // Length Calculation
    // [((L + W) * 2 ) + PinningFleb] Formula

    LengthX =
      parseFloat(PinningFleb) +
      parseFloat(PinningFlebDecVal) +
      2 *
        (parseFloat(length) +
          parseFloat(lengthDecVal) +
          (parseFloat(width) + parseFloat(widthDecVal)));
    if (LengthX > parseFloat(this.state.TotalLength) * 2) {
      LengthX = parseFloat(LengthX) / 4; //FP
      row.SPDP = 3;
    } else if (
      LengthX > parseFloat(this.state.TotalLength) &&
      LengthX <= parseFloat(this.state.TotalLength) * 2
    ) {
      LengthX = parseFloat(LengthX) / 2; //DP
      row.SPDP = 1;
    } else {
      LengthX =
        2 *
        (parseFloat(length) +
          parseFloat(lengthDecVal) +
          (parseFloat(width) + parseFloat(widthDecVal))); //SP
      row.SPDP = 2;
    }
    LengthX = parseFloat(LengthX);
    //LengthX = parseFloat(LengthX) + parseFloat(0.5);
    // LengthX = parseFloat(LengthX) + this.state.LengthIncrement;

    LengthX = LengthX == undefined || LengthX == 0 ? 0 : LengthX.toFixed(2);
    StrLengthX = LengthX > 0 ? LengthX.split(".")[0] : 0;
    StrLengthXMargin =
      LengthX > 0 ? this.ConverttoSoot("." + LengthX.split(".")[1]) : "";

    // Update row with calculated values
    return {
      ...row,
      TLength: LengthX,
      TLengthMargin: StrLengthXMargin,
      LengthMarginDec: LengthX - Math.floor(LengthX),
      LengthX: LengthX + " " + StrLengthXMargin,
    };
  };

  convertMMToInches = value => {
    return parseFloat(value || 0) / 25.4;
  };

  convertCMToInches = value => {
    return parseFloat(value || 0) / 2.54;
  };

  handleCalcLength = row => {
    let LengthX = 0.0;
    let WidthX = 0.0;
    let HeightX = 0.0;
    let TotalHeightX = 0.0;
    let TotalLengthX = 0.0;

    let StrLengthX = "";
    let StrWidthX = "";
    let StrHeightX = "";
    let StrTotalLengthX = "";

    let StrTotalLengthXMargin = "";
    let StrLengthXMargin = "";
    let StrWidthXMargin = "";
    let StrHeightXMargin = "";

    let HeightIncre = 1;
    let fiChange = 0;

    // Get calculation type
    const calcType = parseInt(row.F_CalculationTypeMaster || 0);
    const dpsp = parseInt(row.SPDP || 0);

    // Get basic measurements with unit conversion
    let length, width, height;

    if (row.F_UnitSize == 1) {
      // Convert from mm to inches
      length = this.convertMMToInches(row.Length);
      width = this.convertMMToInches(row.Width);
      height = this.convertMMToInches(row.Height);
      //PinningFleb = this.convertMMToInches(row.Pinning);

      console.log("length", length);
      console.log("width", width);
      console.log("height", height);
    } else if (row.F_UnitSize == 2) {
      // Convert from cm to inches
      length = this.convertCMToInches(row.Length);
      width = this.convertCMToInches(row.Width);
      height = this.convertCMToInches(row.Height);
      //PinningFleb = this.convertCMToInches(row.Pinning);
    } else {
      // Already in inches
      length = parseFloat(row.Length || 0);
      width = parseFloat(row.Width || 0);
      height = parseFloat(row.Height || 0);
      //PinningFleb = parseFloat(row.Pinning || 0);
    }

    const PinningFleb = parseFloat(row.Pinning || 0);
    console.log("PinningFleb", PinningFleb);

    // Get decimal values
    const lengthDecVal = this.ConverttoDecimal(row.LengthMar || 0);
    const widthDecVal = this.ConverttoDecimal(row.WidthMar || 0);
    const heightDecVal = this.ConverttoDecimal(row.HeightMar || 0);
    const PinningFlebDecVal = this.ConverttoDecimal(row.PinningMargin || 0);
    const plyMarginDecVal = this.ConverttoDecimal(row.PlyMargin || 0);

    // Length Calculation
    // if (calcType == 2) {
    //   // Simple Box
    //   PinningFleb = PinningFleb * 2;
    //   PinningFlebDecVal = PinningFlebDecVal * 2;
    // }
    console.log("calType", calcType, "dpsp", dpsp);
    if ([2, 9, 13, 14].includes(calcType)) {
      // Simple Box,   DF, HalfBoxSB, HalfBoxFF
      // [(L + W + PinningFleb ) * 2] Formula
      if (dpsp == 3 || dpsp == "3") {
        //FP
        LengthX = parseFloat(length) + parseFloat(lengthDecVal);
      } else if (dpsp == 1 || dpsp == "1") {
        //DP

        LengthX =
          parseFloat(PinningFleb) +
          parseFloat(PinningFlebDecVal) +
          (parseFloat(length) +
            parseFloat(lengthDecVal) +
            (parseFloat(width) + parseFloat(widthDecVal)));
      } else if (dpsp == 2 || dpsp == "2") {
        //SP
        LengthX =
          parseFloat(PinningFleb) +
          parseFloat(PinningFlebDecVal) +
          2 *
            (parseFloat(length) +
              parseFloat(lengthDecVal) +
              (parseFloat(width) + parseFloat(widthDecVal)));
      }
    } else if (calcType == 12) {
      //Ccap
      //	[(L + (2 * H) + PinningFleb)] Formula
      LengthX =
        parseFloat(length) +
        parseFloat(lengthDecVal) +
        2 * (parseFloat(height) + parseFloat(heightDecVal)) +
        parseFloat(PinningFleb) +
        parseFloat(PinningFlebDecVal);
    }

    // Height Calculation
    if (calcType == 12) {
      //Cap
      //	[(W + (2 * H)+ Safai)] Formula
      HeightX =
        parseFloat(width) +
        parseFloat(widthDecVal) +
        2 * (parseFloat(height) + parseFloat(heightDecVal));
    } else if (calcType == 2) {
      //SB
      // [(W + H + Safai)] Formula
      HeightX =
        parseFloat(width) +
        parseFloat(widthDecVal) +
        (parseFloat(height) + parseFloat(heightDecVal));
    } else if (calcType == 9) {
      //DF
      // [((W * 2) + H + Safai)] Formula
      HeightX =
        (parseFloat(width) + parseFloat(widthDecVal)) * 2 +
        (parseFloat(height) + parseFloat(heightDecVal));
    } else if (calcType == 13) {
      //Half Box SB
      // [((W / 2) + H + Safai)] Formula
      HeightX =
        (parseFloat(width) + parseFloat(widthDecVal)) / 2 +
        (parseFloat(height) + parseFloat(heightDecVal));
    } else if (calcType == 14) {
      //Half Box FF
      // [(W + H + Safai)] Formula
      HeightX =
        parseFloat(width) +
        parseFloat(widthDecVal) +
        (parseFloat(height) + parseFloat(heightDecVal));
    }

    // Width Calculation
    if ([2, 9, 13, 14].includes(calcType)) {
      // Simple Box,   DF, HalfBoxSB, HalfBoxFF
      // [(2 * PinningFleb) + W] Formula
      if (dpsp == 3) {
        //FP
        WidthX =
          2 * (parseFloat(PinningFleb) + parseFloat(PinningFlebDecVal)) +
          (parseFloat(width) + parseFloat(widthDecVal));
      } else {
        WidthX = 0.0;
      }
    }

    // TotalHeightX = parseFloat(HeightX);
    TotalHeightX = Math.round(
      parseFloat(HeightX) + parseFloat(plyMarginDecVal)
    );
    //LengthX = parseFloat(LengthX) + parseFloat(this.state.LengthIncrement);
    // LengthX = parseFloat(LengthX)   ;
    // HeightX = parseFloat(HeightX);

    TotalLengthX = parseFloat(LengthX) + parseFloat(0.5);
    LengthX = parseFloat(LengthX);
    //LengthX = parseFloat(LengthX) + parseFloat(0.5);
    //LengthX = parseFloat(LengthX);

    HeightX = Math.round(parseFloat(HeightX) + parseFloat(plyMarginDecVal));
    console.log("pehla", TotalHeightX);
    console.log("pehla1", HeightX);

    // HeightX = parseFloat(HeightX) + parseFloat(plyMarginDecVal);

    TotalLengthX =
      TotalLengthX == undefined || TotalLengthX == 0
        ? 0
        : TotalLengthX.toFixed(2);
    LengthX = LengthX == undefined || LengthX == 0 ? 0 : LengthX.toFixed(2);
    WidthX = WidthX == undefined || WidthX == 0 ? 0 : WidthX.toFixed(2);
    HeightX = HeightX == undefined || HeightX == 0 ? 0 : HeightX.toFixed(2);

    StrLengthX = LengthX > 0 ? LengthX.split(".")[0] : 0;
    StrWidthX = WidthX > 0 ? WidthX.split(".")[0] : 0;
    StrHeightX = HeightX > 0 ? HeightX.split(".")[0] : 0;
    StrTotalLengthX = TotalLengthX > 0 ? TotalLengthX.split(".")[0] : 0;

    StrTotalLengthXMargin =
      TotalLengthX > 0
        ? this.ConverttoSoot("." + TotalLengthX.split(".")[1])
        : "";
    StrLengthXMargin =
      LengthX > 0 ? this.ConverttoSoot("." + LengthX.split(".")[1]) : "";
    StrWidthXMargin =
      WidthX > 0 ? this.ConverttoSoot("." + WidthX.split(".")[1]) : "";
    StrHeightXMargin =
      HeightX > 0 ? this.ConverttoSoot("." + HeightX.split(".")[1]) : "";

    console.log("StrLengthXMargin", StrLengthXMargin);

    //Height Reset Calculation
    let count2 = 2;
    let count3 = 3;
    let count4 = 4;
    let count5 = 5;

    const minHeight = parseFloat(this.state.MinHeight);

    if (HeightX < minHeight) {
      const heightX2 = HeightX * 2;
      const heightX3 = HeightX * 3;
      const heightX4 = HeightX * 4;

      if (heightX2 < minHeight) {
        TotalHeightX = HeightX * count3;
        HeightIncre = count3;
      } else if (heightX3 < minHeight) {
        TotalHeightX = HeightX * count4;
        HeightIncre = count4;
      } else if (heightX4 < minHeight) {
        TotalHeightX = HeightX * count5;
        HeightIncre = count5;
      } else {
        TotalHeightX = HeightX * count2;
        HeightIncre = count2;
      }
    }

    // Calculate sheet quantities
    const lengthInc = parseFloat(row.LengthIncre || 0);
    const heightInc = parseFloat(HeightIncre || 0);
    const boxQty = parseFloat(row.NoOfBox || 0);

    let sheetQty = 0;

    if (fiChange == 0) {
      if (lengthInc > 0) {
        sheetQty = boxQty / (lengthInc * heightInc);

        if (row.SPDP == 3) {
          // FP
          sheetQty *= 2;
        } else if (row.SPDP == 1) {
          // DP
          sheetQty *= 2;
        }
      }
    }
    console.log("asd", HeightX);
    console.log("asd", TotalHeightX);
    // Update row with calculated values
    return {
      ...row,
      LengthMarDec: lengthDecVal,
      WidthMarDec: widthDecVal,
      HeightMarDec: heightDecVal,
      PinningMarDec: PinningFlebDecVal,
      PinningFlebDecVal: PinningFlebDecVal,
      TLength: LengthX,
      TLengthMargin: this.ConverttoSoot(LengthX - Math.floor(LengthX)),
      LengthMarginDec: LengthX - Math.floor(LengthX),
      LengthXDec: LengthX - Math.floor(LengthX),
      THeight: HeightX,
      THeightMargin: this.ConverttoSoot(HeightX - Math.floor(HeightX)),
      HeightMarginDec: HeightX - Math.floor(HeightX),
      HeightXDec: HeightX - Math.floor(HeightX),
      TWidth: Math.floor(WidthX),
      TWidthMargin: this.ConverttoSoot(WidthX - Math.floor(WidthX)),
      WidthMarginDec: WidthX - Math.floor(WidthX),
      WidthXDec: WidthX - Math.floor(WidthX),
      // LengthX: LengthX + " " + StrLengthXMargin,
      LengthX: Math.floor(TotalLengthX) + " " + StrTotalLengthXMargin,
      X: "X",

      HeightX:
        Math.ceil(TotalHeightX) % 2 == 0
          ? Math.ceil(TotalHeightX)
          : Math.ceil(TotalHeightX) + 1,
      SheetQty: Math.round(sheetQty),
      HeightIncre: HeightIncre,
    };
  };

  CalcSheet = row => {
    var sheet = 0;
    var box = parseFloat(row.NoOfBox || 0);
    const equaltobox = (row.LengthIncre * row.WidthIncr).toFixed(1);

    sheet = (box / equaltobox).toFixed(2);
    sheet = sheet > 0 ? parseInt(sheet) : 0;

    return sheet;
  };

  MinMaxCalculation = (totalValue, ssMin, ssMax, ssGap = 2) => {
    // Convert to number if string
    totalValue = parseFloat(totalValue);
    ssMin = parseInt(ssMin);
    ssMax = parseInt(ssMax);
    ssGap = parseInt(ssGap);

    // Get integer and decimal parts
    const intPart = Math.floor(totalValue);
    const decPart = totalValue - intPart;

    // Check if integer part is even and decimal part is between 0 and 0.75
    if (intPart % 2 == 0 && decPart > 0 && decPart < 0.75) {
      totalValue = intPart;
    }

    // If min and max are different, find the next valid value
    if (ssMin !== ssMax) {
      for (let i = ssMin; i <= ssMax; i += ssGap) {
        if (totalValue <= i) {
          totalValue = i;
          break;
        }
      }
    }

    return totalValue;
  };

  CalculateBoxSize = (
    row,
    fiChange = 0,
    lSSMin = 0,
    lSSGap = 0,
    lSSMax = 0,
    lLengthMax = 0
  ) => {
    let LengthX = 0.0;
    let WidthX = 0.0;
    let HeightX = 0.0;
    let TotalHeightX = 0.0;
    let TotalLengthX = 0.0;

    let StrTotalLengthX = "";
    let StrLengthX = "";
    let StrWidthX = "";
    let StrHeightX = "";

    let StrTotalLengthXMargin = "";
    let StrLengthXMargin = "";
    let StrWidthXMargin = "";
    let StrHeightXMargin = "";

    let HeightIncre = 1;

    // Get calculation type
    const calcType = parseInt(row.F_CalculationTypeMaster || 0);
    const dpsp = parseInt(row.SPDP || 0);

    // Get basic measurements
    // const length = parseFloat(row.Length || 0);
    // const width = parseFloat(row.Width || 0);
    // const height = parseFloat(row.Height || 0);
    //const PinningFleb = parseFloat(row.Pinning || 0);

    // Get basic measurements with unit conversion
    let length, width, height;

    if (row.F_UnitSize == 1) {
      // Convert from mm to inches
      length = this.convertMMToInches(row.Length);
      width = this.convertMMToInches(row.Width);
      height = this.convertMMToInches(row.Height);
      // PinningFleb = this.convertMMToInches(row.Pinning);
    } else if (row.F_UnitSize == 2) {
      // Convert from cm to inches
      length = this.convertCMToInches(row.Length);
      width = this.convertCMToInches(row.Width);
      height = this.convertCMToInches(row.Height);
      //PinningFleb = this.convertCMToInches(row.Pinning);
    } else {
      // Already in inches
      length = parseFloat(row.Length || 0);
      width = parseFloat(row.Width || 0);
      height = parseFloat(row.Height || 0);
      // PinningFleb = parseFloat(row.Pinning || 0);
    }

    const PinningFleb = parseFloat(row.Pinning || 0);
    console.log("PinningFleb", PinningFleb);

    // Get decimal values
    const lengthDecVal = this.ConverttoDecimal(row.LengthMar || 0);
    const widthDecVal = this.ConverttoDecimal(row.WidthMar || 0);
    const heightDecVal = this.ConverttoDecimal(row.HeightMar || 0);
    const PinningFlebDecVal = this.ConverttoDecimal(row.PinningMargin || 0);
    const plyMarginDecVal = this.ConverttoDecimal(row.PlyMargin || 0);

    // Length Calculation
    // if (calcType == 2) {
    //   // Simple Box
    //   PinningFleb *= 2;
    //   PinningFlebDecVal *= 2;
    // }

    // First calculate the base LengthX without considering SPDP
    let baseLengthX = 0;
    
    if ([2, 9, 13, 14].includes(calcType)) {
      // Simple Box, DF, HalfBoxSB, HalfBoxFF
      // Calculate base length: [(L + W + PinningFleb) * 2]
      baseLengthX =
        parseFloat(PinningFleb) +
        parseFloat(PinningFlebDecVal) +
        2 *
          (parseFloat(length) +
            parseFloat(lengthDecVal) +
            (parseFloat(width) + parseFloat(widthDecVal)));
    } else if (calcType == 12) {
      // Ccap
      // [(L + (2 * H) + PinningFleb)] Formula
      baseLengthX =
        parseFloat(length) +
        parseFloat(lengthDecVal) +
        2 * (parseFloat(height) + parseFloat(heightDecVal)) +
        parseFloat(PinningFleb) +
        parseFloat(PinningFlebDecVal);
    }
    
    // Auto-determine SPDP based on baseLengthX and TotalLength
    // But only if SPDP is 0 (not manually set)
    const totalLength = parseFloat(this.state.TotalLength) || 105;
    let newDpsp = dpsp;
    
    // Only auto-determine SPDP if it's currently 0 (not manually set)
    if (dpsp === 0 && baseLengthX > 0) {
      if (Math.abs(baseLengthX - totalLength) < 0.1) {
        // LengthX approximately equals TotalLength - set to DP (1)
        newDpsp = 1;
      } else if (baseLengthX < totalLength) {
        // LengthX less than TotalLength - set to SP (2)
        newDpsp = 2;
      } else if (baseLengthX >= totalLength * 2) {
        // LengthX is double or more than TotalLength - set to FP (3)
        newDpsp = 3;
      }
    }
    
    // Now calculate LengthX based on the determined SPDP value
    if ([2, 9, 13, 14].includes(calcType)) {
      if (newDpsp == 3 || newDpsp == "3") {
        // FP (Four Panel) - Length = L + L_Margin
        LengthX = parseFloat(length) + parseFloat(lengthDecVal);
      } else if (newDpsp == 1 || newDpsp == "1") {
        // DP (Double Panel) - Length = PinningFleb + (L + W + PinningFleb)
        LengthX =
          parseFloat(PinningFleb) +
          parseFloat(PinningFlebDecVal) +
          (parseFloat(length) +
            parseFloat(lengthDecVal) +
            (parseFloat(width) + parseFloat(widthDecVal)));
      } else if (newDpsp == 2 || newDpsp == "2") {
        // SP (Single Panel) - Length = PinningFleb + 2*(L + W)
        LengthX =
          parseFloat(PinningFleb) +
          parseFloat(PinningFlebDecVal) +
          2 *
            (parseFloat(length) +
              parseFloat(lengthDecVal) +
              (parseFloat(width) + parseFloat(widthDecVal)));
      }
    } else if (calcType == 12) {
      // Ccap - no SPDP adjustment needed
      LengthX = baseLengthX;
    }

    console.log("LenX", LengthX);

    // Width Calculation
    if ([2, 9, 13, 14].includes(calcType)) {
      // Simple Box, DF, HalfBoxSB, HalfBoxFF
      if (newDpsp == 3 || newDpsp == "3") {
        // FP (Four Panel) - Width = 2*PinningFleb + W + W_Margin
        WidthX =
          2 * (parseFloat(PinningFleb) + parseFloat(PinningFlebDecVal)) +
          (parseFloat(width) + parseFloat(widthDecVal));
      } else {
        // DP and SP don't use width calculation
        WidthX = 0.0;
      }
    }

    // Height Calculation
    if (calcType == 12) {
      //Cap
      //	[(W + (2 * H)+ Safai)] Formula
      HeightX =
        parseFloat(width) +
        parseFloat(widthDecVal) +
        2 * (parseFloat(height) + parseFloat(heightDecVal));
    } else if (calcType == 2) {
      //SB
      // [(W + H + Safai)] Formula
      HeightX =
        parseFloat(width) +
        parseFloat(widthDecVal) +
        (parseFloat(height) + parseFloat(heightDecVal));
    } else if (calcType == 9) {
      //DF
      // [((W * 2) + H + Safai)] Formula
      HeightX =
        (parseFloat(width) + parseFloat(widthDecVal)) * 2 +
        (parseFloat(height) + parseFloat(heightDecVal));
    } else if (calcType == 13) {
      //Half Box CF
      // [((W / 2) + H + Safai)] Formula
      HeightX =
        (parseFloat(width) + parseFloat(widthDecVal)) / 2 +
        (parseFloat(height) + parseFloat(heightDecVal));
    } else if (calcType == 14) {
      //Half Box FF
      // [(W + H + Safai)] Formula
      HeightX =
        parseFloat(width) +
        parseFloat(widthDecVal) +
        (parseFloat(height) + parseFloat(heightDecVal));
    }

    // Width Calculation
    //TotalHeightX = parseFloat(HeightX) + parseFloat(plyMarginDecVal);
    TotalHeightX = Math.round(
      parseFloat(HeightX) + parseFloat(plyMarginDecVal)
    );
    // LengthX = parseFloat(LengthX) + parseFloat(this.state.LengthIncrement);
    TotalLengthX = parseFloat(LengthX) + parseFloat(0.5);
    LengthX = parseFloat(LengthX);
    //LengthX = parseFloat(LengthX);

    HeightX = Math.round(parseFloat(HeightX) + parseFloat(plyMarginDecVal));
    console.log("duja", TotalHeightX);
    console.log("duja1", HeightX);

    // HeightX = parseFloat(HeightX) + parseFloat(plyMarginDecVal);

    TotalLengthX =
      TotalLengthX == undefined || TotalLengthX == 0
        ? 0
        : TotalLengthX.toFixed(2);
    LengthX = LengthX == undefined || LengthX == 0 ? 0 : LengthX.toFixed(2);
    WidthX = WidthX == undefined || WidthX == 0 ? 0 : WidthX.toFixed(2);
    HeightX = HeightX == undefined || HeightX == 0 ? 0 : HeightX.toFixed(2);

    StrTotalLengthX = TotalLengthX > 0 ? TotalLengthX.split(".")[0] : 0;
    StrLengthX = LengthX > 0 ? LengthX.split(".")[0] : 0;
    StrWidthX = WidthX > 0 ? WidthX.split(".")[0] : 0;
    StrHeightX = HeightX > 0 ? HeightX.split(".")[0] : 0;

    StrTotalLengthXMargin =
      TotalLengthX > 0
        ? this.ConverttoSoot("." + TotalLengthX.split(".")[1])
        : "";
    StrLengthXMargin =
      LengthX > 0 ? this.ConverttoSoot("." + LengthX.split(".")[1]) : "";
    StrWidthXMargin =
      WidthX > 0 ? this.ConverttoSoot("." + WidthX.split(".")[1]) : "";
    StrHeightXMargin =
      HeightX > 0 ? this.ConverttoSoot("." + HeightX.split(".")[1]) : "";

    console.log("StrLengthXMargin", StrLengthXMargin);

    //Height Reset Calculation
    let count2 = 2;
    let count3 = 3;
    let count4 = 4;
    let count5 = 5;

    const minHeight = parseFloat(this.state.MinHeight);

    if (HeightX < minHeight) {
      const heightX2 = HeightX * 2;
      const heightX3 = HeightX * 3;
      const heightX4 = HeightX * 4;

      if (heightX2 < minHeight) {
        TotalHeightX = HeightX * count3;
        HeightIncre = count3;
      } else if (heightX3 < minHeight) {
        TotalHeightX = HeightX * count4;
        HeightIncre = count4;
      } else if (heightX4 < minHeight) {
        TotalHeightX = HeightX * count5;
        HeightIncre = count5;
      } else {
        TotalHeightX = HeightX * count2;
        HeightIncre = count2;
      }
    }
    // Calculate sheet quantities
    const lengthInc = parseFloat(row.LengthIncre || 0);
    const heightInc = parseFloat(HeightIncre || 0);
    const boxQty = parseFloat(row.NoOfBox || 0);

    let sheetQty = 0;

    if (fiChange == 0) {
      if (lengthInc > 0) {
        sheetQty = boxQty / (lengthInc * heightInc);

        if (newDpsp == 3 || newDpsp == "3") {
          // FP (Four Panel) - double the sheet quantity
          sheetQty *= 2;
        } else if (newDpsp == 1 || newDpsp == "1") {
          // DP (Double Panel) - double the sheet quantity
          sheetQty *= 2;
        }
        // SP (Single Panel) - no multiplication needed
      }
    }
    console.log("asd_1", HeightX);
    console.log("asd_1", TotalHeightX);

    // Update row with calculated values
    return {
      ...row,
      SPDP: newDpsp, // Update SPDP with the determined value (auto or manual)
      TLength: Math.floor(LengthX),
      TLengthMargin: StrLengthXMargin,
      LengthMarginDec: LengthX - Math.floor(LengthX),
      THeight: Math.floor(HeightX),
      THeightMargin: StrHeightXMargin,
      HeightMarginDec: HeightX - Math.floor(HeightX),
      HeightXDec: HeightX - Math.floor(HeightX),
      TWidth: Math.floor(WidthX),
      TWidthMargin: StrWidthXMargin,
      WidthMarginDec: WidthX - Math.floor(WidthX),
      WidthXDec: WidthX - Math.floor(WidthX),
      //   LengthX: Math.floor(LengthX) + " " + StrLengthXMargin,
      LengthX: Math.floor(TotalLengthX) + " " + StrTotalLengthXMargin,
      LengthXDec: LengthX - Math.floor(LengthX),
      X: "X",

      HeightX:
        Math.ceil(TotalHeightX) % 2 == 0
          ? Math.ceil(TotalHeightX)
          : Math.ceil(TotalHeightX) + 1,
      SheetQty: Math.round(sheetQty),
      HeightIncre: HeightIncre,
    };
  };

  CalculateWidthValue = (width, widthDecVal, plyMarginDecVal, calcType = 0) => {
    if (calcType == 2 || calcType == 13) {
      // SB or HalfBox CF
      return (width + widthDecVal) / 2 + plyMarginDecVal;
    }
    return width + widthDecVal + plyMarginDecVal;
  };

  handleInputChange = async (index, field, value) => {
    const sheetRows = [...this.state.sheetRows];
    sheetRows[index][field] = value;
    if (field == "CodeNo") {
      console.log("CodeNo", value);
      if (
        value &&
        value.trim() !== "" &&
        this.state.F_LedgerMaster &&
        this.state.F_LedgerMaster !== "" &&
        this.state.F_LedgerMaster !== 0
      ) {
        const res = await Fn_FillListData(
          this.obj,
          "newMaster",
          API_WEB_URLS.MASTER +
            "/0/token/SearchByCode/" +
            value +
            "/" +
            this.state.F_LedgerMaster
        );
        console.log("res", res);
        if (res && res.length > 0) {
          const data = res[0];
          // Update all the fields from the API response
          sheetRows[index] = {
            ...sheetRows[index],
            OrderDate: this.state.OrderDate2 || today,
            DOD2: this.state.DOD2 || today,
            CodeNo: data.CodeNo,
            F_UnitSize: data.F_UnitSize,
            F_PlyMaster: data.F_PlyMaster,
            PlyMargin: data.PlyMargin,
            Length: data.Length,
            LengthMar: data.LengthMar,
            Width: data.Width,
            WidthMar: data.WidthMar,
            Height: data.Height,
            HeightMar: data.HeightMar,
            LengthManual: data.LengthManual,
            LengthManualMargin: data.LengthManualMargin,
            WidthManual: data.WidthManual,
            WidthManualMargin: data.WidthManualMargin,
            HeightManual: data.HeightManual,
            HeightManualMargin: data.HeightManualMargin,
            Pinning: data.Pinning,
            PinningMargin: data.PinningMargin,
            F_TypeMaster: data.F_TypeMaster,
            InOut: data.InOut,
            F_CalculationTypeMaster: data.F_CalculationTypeMaster,
            NoOfBox: data.NoOfBox,
            SPDP: data.SPDP,
            TLength: data.TLength,
            TLengthMargin: data.LengthMargin,
            LengthIncre: data.LengthIncre,
            BlankIncre: data.BlankIncre,
            THeight: data.THeight,
            THeightMargin: data.HeightMargin,
            HeightIncre: data.HeightIncre,
            TWidth: data.TWidth,
            TWidthMargin: data.WidthMargin,
            WidthIncre: data.WidthIncre,
            LengthX: data.LengthX,
            HeightX: data.HeightX,
            WidthX: data.WidthX,
            ShortQty: data.ShortQty,
            IsCompleted: data.IsCompleted,
            IsPaste: data.IsPaste,
            IsPrint: data.IsPrint,
            F_PrintDescriptionMaster: data.F_PrintDescriptionMaster,
            PlyMarginDec: data.PlyMarginDec,
            LengthMarDec: data.LengthMarDec,
            WidthMarDec: data.WidthMarDec,
            HeightMarDec: data.HeightMarDec,
            PinningMarginDec: data.PinningMarginDec,
            LengthMarginDec: data.LengthMarginDec,
            HeightMarginDec: data.HeightMarginDec,
            WidthMarginDec: data.WidthMarginDec,
            HalfWidth: data.HalfWidth,
            HalfWidthMar: data.HalfWidthMar,
            HalfWidthMarDec: data.HalfWidthMarDec,
            F_ItemTypeMaster: data.F_ItemTypeMaster,
            LengthXDec: data.LengthXDec,
            HeightXDec: data.HeightXDec,
            WidthXDec: data.WidthXDec,
            LengthIncrement: data.LengthIncrement,
          };
        } else {
          // Reset sheet sizing data when no results found
          sheetRows[index] = {
            ...sheetRows[index],
            OrderDate: this.state.OrderDate2 || today,
            DOD2: this.state.DOD2 || today,
            CodeNo: value, // Keep the entered CodeNo
            F_UnitSize: 3,
            F_UnitType: 0,
            F_PlyMaster: 0,
            PlyMargin: "",
            Length: 0,
            LengthMar: "",
            Width: 0,
            WidthMar: "",
            Height: 0,
            HeightMar: "",
            LengthManual: 0,
            LengthManualMargin: "",
            WidthManual: 0,
            WidthManualMargin: "",
            HeightManual: 0,
            HeightManualMargin: "",
            Pinning: 0,
            PinningMargin: "",
            F_TypeMaster: 0,
            InOut: 0,
            F_CalculationTypeMaster: 0,
            NoOfBox: 0,
            SPDP: 0,
            TLength: 0,
            TLengthMargin: "",
            LengthIncre: 1,
            LengthIncrement: 0.5,
            BlankIncre: 0,
            THeight: 0,
            THeightMargin: "",
            HeightIncre: 1,
            TWidth: 0,
            TWidthMargin: "",
            WidthIncre: 1,
            LengthX: "",
            X: "X",
            HeightX: "",
            WidthX: "",
            ShortQty: 0,
            IsCompleted: false,
            IsPaste: false,
            IsPrint: false,
            F_PrintDescriptionMaster: 0,
            PlyMarginDec: 0,
            LengthMarDec: 0,
            WidthMarDec: 0,
            HeightMarDec: 0,
            PinningMarginDec: 0,
            LengthMarginDec: 0,
            HeightMarginDec: 0,
            WidthMarginDec: 0,
            HalfWidth: 0,
            HalfWidthMar: "",
            HalfWidthMarDec: 0,
            F_ItemTypeMaster: 0,
            LengthXDec: 0,
            HeightXDec: 0,
            WidthXDec: 0,
          };
        }
      } else if (!value || value.trim() === "") {
        // Reset the row when CodeNo is empty
        sheetRows[index] = {
          ...sheetRows[index],
          OrderDate: today,
          DOD2: today,
          CodeNo: "",
          F_UnitSize: 3,
          F_UnitType: 0,
          F_PlyMaster: 0,
          PlyMargin: "",
          Length: 0,
          LengthMar: "",
          Width: 0,
          WidthMar: "",
          Height: 0,
          HeightMar: "",
          LengthManual: 0,
          LengthManualMargin: "",
          WidthManual: 0,
          WidthManualMargin: "",
          HeightManual: 0,
          HeightManualMargin: "",
          Pinning: 0,
          PinningMargin: "",
          F_TypeMaster: 0,
          InOut: 0,
          F_CalculationTypeMaster: 0,
          NoOfBox: 0,
          SPDP: 0,
          TLength: 0,
          TLengthMargin: "",
          LengthIncre: 1,
          LengthIncrement: 0.5,
          BlankIncre: 0,
          THeight: 0,
          THeightMargin: "",
          HeightIncre: 1,
          TWidth: 0,
          TWidthMargin: "",
          WidthIncre: 1,
          LengthX: "",
          X: "X",
          HeightX: "",
          WidthX: "",
          ShortQty: 0,
          IsCompleted: false,
          IsPaste: false,
          IsPrint: false,
          F_PrintDescriptionMaster: 0,
          PlyMarginDec: 0,
          LengthMarDec: 0,
          WidthMarDec: 0,
          HeightMarDec: 0,
          PinningMarginDec: 0,
          LengthMarginDec: 0,
          HeightMarginDec: 0,
          WidthMarginDec: 0,
          HalfWidth: 0,
          HalfWidthMar: "",
          HalfWidthMarDec: 0,
          F_ItemTypeMaster: 0,
          LengthXDec: 0,
          HeightXDec: 0,
          WidthXDec: 0,
        };
      }
    }
    // if(field == "F_UnitSize" && value == 1 || value == 2){
    //   sheetRows[index].LengthMar = 0;
    //   sheetRows[index].WidthMar = 0;
    //   sheetRows[index].HeightMar = 0;
    //   sheetRows[index].LengthManualMargin = 0;
    //   sheetRows[index].WidthManualMargin = 0;
    //   sheetRows[index].HeightManualMargin = 0;
    // }

    // Auto-update PlyMargin when F_PlyMaster changes
    if (field == "F_PlyMaster") {
      const selectedPly = this.state.Ply.find(p => p.Id == value);
      sheetRows[index]["PlyMargin"] = selectedPly?.LeadPastingPlyMargin || "";
    }

    this.setState({ sheetRows });

    // Auto-copy values between Length/LengthMar and LengthManual/LengthManualMargin
    if (field == "Length") {
      sheetRows[index].LengthManual = value;
    } else if (field == "LengthManual") {
      sheetRows[index].Length = value;
    } else if (field == "LengthMar") {
      sheetRows[index].LengthManualMargin = value;
    } else if (field == "LengthManualMargin") {
      sheetRows[index].LengthMar = value;
    }

    // Auto-copy values between Width/WMargin and WidthManual/WidthManualMargin
    if (field == "Width") {
      sheetRows[index].WidthManual = value;
    } else if (field == "WidthManual") {
      sheetRows[index].Width = value;
    } else if (field == "WidthMar") {
      sheetRows[index].WidthManualMargin = value;
    } else if (field == "WidthManualMargin") {
      sheetRows[index].WidthMar = value;
    }

    // Auto-copy values between Height/HMargin and HeightManual/HeightManualMargin
    if (field == "Height") {
      sheetRows[index].HeightManual = value;
    } else if (field == "HeightManual") {
      sheetRows[index].Height = value;
    } else if (field == "HeightMar") {
      sheetRows[index].HeightManualMargin = value;
    } else if (field == "HeightManualMargin") {
      sheetRows[index].HeightMar = value;
    }

    // Special handling for F_UnitSize = 1 or 2
    if (field == "F_UnitSize" && (value == "1" || value == "2")) {
      // Copy LengthMar to LengthManualMargin
      if (sheetRows[index].LengthMar) {
        sheetRows[index].LengthManualMargin = sheetRows[index].LengthMar;
      }
      // Copy WidthMar to WidthManualMargin
      if (sheetRows[index].WidthMar) {
        sheetRows[index].WidthManualMargin = sheetRows[index].WidthMar;
      }
      // Copy HeightMar to HeightManualMargin
      if (sheetRows[index].HeightMar) {
        sheetRows[index].HeightManualMargin = sheetRows[index].HeightMar;
      }
      // Copy PinningMar to PinningFlebMargin
      if (sheetRows[index].PinningMargin) {
        sheetRows[index].PinningFlebMargin = sheetRows[index].PinningMargin;
      }
      // Copy PlyMargin to PlyMarginDec
      if (sheetRows[index].PlyMargin) {
        sheetRows[index].PlyMarginDec = sheetRows[index].PlyMargin;
      }
    }

    if (field === "SPDP") {
      // Update the SPDP value first
      sheetRows[index].SPDP = value;
      
      // Recalculate all values based on the new SPDP value
      // This will trigger a complete recalculation using CalculateBoxSize
      sheetRows[index] = this.CalculateBoxSize(sheetRows[index]);
    }

    // If calculation type changes, update DP/SP value
    if (field == "F_CalculationTypeMaster") {
      sheetRows[index] = this.handleCalcLength(sheetRows[index], value);
    }

    // If any of the calculation fields change, recalculate
    if (
      [
        "Length",
        "LengthMar",
        "Height",
        "HeightMar",
        "Width",
        "WidthMar",
        "F_CalculationType",
        "WidthIncre",
        "LengthIncre",
        "NoOfBox",
        "HeightX",
        "WidthX",
        "LengthX",
        "HeightIncre",
        "F_CalculationTypeMaster",
        "LengthManual",
        "LengthManualMargin",
        "HeightManualMargin",
        "WidthManualMargin",
        "WidthManual",
        "Pinning",
        "PinningMargin",
      ].includes(field)
    ) {
      // Then calculate box size and update row (SPDP will be auto-determined only if not manually set)
      sheetRows[index] = this.CalculateBoxSize(sheetRows[index]);
    }

    const totalQty = sheetRows.reduce((sum, row) => {
      const qty = parseFloat(row.NoOfBox);
      return sum + (isNaN(qty) ? 0 : qty);
    }, 0);

    this.setState({
      sheetRows,
      TotalQty: totalQty,
    });
  };

  handleAddRow = () => {
    // Check if there are existing rows and if the last row's NoOfBox is greater than 0
    if (this.state.sheetRows.length > 0) {
      const lastRow = this.state.sheetRows[this.state.sheetRows.length - 1];
      const lastRowNoOfBox = parseFloat(lastRow.NoOfBox || 0);

      if (lastRowNoOfBox <= 0) {
        alert(
          "Please enter a valid NoOfBox value greater than 0 in the current row before adding a new row."
        );
        return;
      }
    }

    // Get the F_UnitSize value from the last row, or default to 3 for first row
    const lastRowUnitSize =
      this.state.sheetRows.length > 0
        ? this.state.sheetRows[this.state.sheetRows.length - 1].F_UnitSize
        : 3;

    const newRow = {
      OrderDate: today,
      DOD2: today,
      CodeNo: "",
      F_UnitType: 0,
      F_UnitSize: lastRowUnitSize, // Use last row's value or 3 for first row
      F_PlyMaster: 0,
      PlyMargin: "",
      Length: 0,
      LengthMar: "",
      Width: 0,
      WidthMar: "",
      Height: 0,
      HeightMar: "",
      LengthManual: 0,
      LengthManualMargin: "",
      WidthManual: 0,
      WidthManualMargin: "",
      HeightManual: 0,
      HeightManualMargin: "",
      Pinning: 0,
      PinningMargin: "",
      F_TypeMaster: 0,
      InOut: 0,
      F_CalculationTypeMaster: 0,
      NoOfBox: 0,
      SPDP: 0,
      TLength: 0,
      TLengthMargin: "",
      LengthIncre: 1,
      LengthIncrement: 0.5,
      BlankIncre: 0,
      THeight: 0,
      THeightMargin: "",
      HeightIncre: 1,
      TWidth: 0,
      TWidthMargin: "",
      WidthIncre: 1,
      LengthX: "",
      HeightX: "",
      WidthX: "",
      ShortQty: 0,
      IsCompleted: false,
      IsPaste: false,
      IsPrint: false,
      F_PrintDescriptionMaster: 0,
      PlyMarginDec: 0,
      LengthMarDec: 0,
      WidthMarDec: 0,
      HeightMarDec: 0,
      PinningMarginDec: 0,
      LengthMarginDec: 0,
      HeightMarginDec: 0,
      WidthMarginDec: 0,
      HalfWidth: 0,
      HalfWidthMar: "",
      HalfWidthMarDec: 0,
      F_ItemTypeMaster: 0,
      LengthXDec: 0,
      HeightXDec: 0,
      WidthXDec: 0,
    };
    this.setState(prevState => ({
      sheetRows: [...prevState.sheetRows, newRow],
    }));
  };

  handleDeleteRow = index => {
    this.setState(prevState => {
      const newRows = prevState.sheetRows.filter((_, i) => i !== index);
      const totalQty = newRows.reduce(
        (sum, row) => sum + Number(row.SheetQty || 0),
        0
      );
      return {
        sheetRows: newRows,
        TotalQty: totalQty,
      };
    });
  };

  ConverttoDecimal = fraction => {
    const map = {
      "1/8": 0.125,
      0.12: 0.125,
      0.13: 0.125,

      "1/4": 0.25,
      0.24: 0.25,
      0.26: 0.25,
      0.28: 0.25,

      "3/8": 0.375,
      0.37: 0.375,
      0.38: 0.375,

      "1/2": 0.5,
      0.49: 0.5,
      0.51: 0.5,
      0.53: 0.5,
      0.41: 0.5,

      "5/8": 0.625,
      0.62: 0.625,
      0.63: 0.625,

      "3/4": 0.75,
      0.73: 0.75,
      0.74: 0.75,
      0.76: 0.75,
      0.64: 0.75,

      "7/8": 0.875,
      0.86: 0.875,
      0.88: 0.875,

      1: 1.0,
      0.99: 1.0,
      1.01: 1.0,

      "-1/8": -0.125,
      "-0.12": -0.125,
      "-0.13": -0.125,

      "-1/4": -0.25,
      "-0.24": -0.25,
      "-0.26": -0.25,

      "-3/8": -0.375,
      "-0.37": -0.375,
      "-0.38": -0.375,

      "-1/2": -0.5,
      "-0.49": -0.5,
      "-0.51": -0.5,
      "-0.53": -0.5,
      "-0.41": -0.5,

      "-5/8": -0.625,
      "-0.62": -0.625,
      "-0.63": -0.625,

      "-3/4": -0.75,
      "-0.73": -0.75,
      "-0.74": -0.75,
      "-0.76": -0.75,
      "-0.64": -0.75,

      "-7/8": -0.875,
      "-0.86": -0.875,
      "-0.88": -0.875,

      "-1": -1.0,
      "-0.99": -1.0,
      "-1.01": -1.0,
    };

    return map[fraction] ?? 0;
  };

  ConverttoSoot = decimalValue => {
    const value = Number(decimalValue);
    const epsilon = 0.02; // Acceptable margin for approximations

    // Map of decimal values to inch fractions
    const sootMap = {
      0.125: "1/8",
      0.25: "1/4",
      0.28: "1/4",
      0.375: "3/8",
      0.5: "1/2",
      0.625: "5/8",
      0.75: "3/4",
      0.875: "7/8",
      1.0: "1",
    };

    // Iterate through the map to find the closest match
    for (const [decimalStr, label] of Object.entries(sootMap)) {
      const num = parseFloat(decimalStr);
      if (Math.abs(value - num) < epsilon) return label;
      if (Math.abs(value + num) < epsilon) return `-${label}`;
    }

    return ""; // No match found
  };

  btnSave_onClick = async event => {
    event.preventDefault();

    try {
      // ===== VALIDATE AND FILTER ROWS =====
      // Filter out rows that don't have NoOfBox > 0
      const validRows = this.state.sheetRows.filter(row => {
        const noOfBox = parseFloat(row.NoOfBox || 0);
        return noOfBox > 0;
      });

      // Check if we have any valid rows
      if (validRows.length === 0) {
        alert(
          "Please enter at least one row with NoOfBox quantity greater than 0 before saving."
        );
        return;
      }

      // If we removed some rows, update the state to reflect the filtered rows
      if (validRows.length !== this.state.sheetRows.length) {
        // Calculate new total quantity
        const newTotalQty = validRows.reduce((sum, row) => {
          const qty = parseFloat(row.NoOfBox || 0);
          return sum + (isNaN(qty) ? 0 : qty);
        }, 0);

        // Update state with filtered rows
        this.setState({
          sheetRows: validRows,
          TotalQty: newTotalQty,
        });
      }

      // ===== HEADER FORM DATA =====
      const headerFormData = new FormData();
      headerFormData.append("VoucherDate", this.state.voucherDate || "");
      headerFormData.append("F_LedgerMaster", this.state.F_LedgerMaster || "");
      headerFormData.append("TotalQty", this.state.TotalQty || "");
      headerFormData.append("DOD", this.state.DOD || "");
      headerFormData.append("OrderDate2", this.state.OrderDate2 || "");
      headerFormData.append("UnitName", this.state.UnitName || "");
      headerFormData.append("VoucherNo", this.state.F_VoucherNo || "");
      headerFormData.append("OrderNo", this.state.OrderNo || "");
      headerFormData.append("F_OrderDetailH", this.state.OrderId || "");
      // --- Sheet rows ---
      validRows.forEach((row, index) => {
        const tLength = this.MinMaxCalculation(row.TLength);
        const tHeight = this.MinMaxCalculation(row.THeight);
        const tWidth = this.MinMaxCalculation(row.TWidth);

        // Object.keys(row).forEach(key => {
        //   const value =
        //     key == "TLength"
        //       ? tLength
        //       : key == "THeight"
        //       ? tHeight
        //       : key == "TWidth"
        //       ? tWidth
        //       : row[key] || "";
        //   headerFormData.append(`rows[${index}].${key}`, value);
        // });
      });

      // === SAVE LINE ITEMS ===
      const res = await Fn_AddEditData(
        this.obj,
        {
          arguList: { id: this.state.voucherNo || 0, formData: headerFormData },
        },
        this.API_URL_SAVEL,
        this.pushFormName,
        true
      );
      console.log("res-----------------------------------------", res);
      var headerFormDataL = new FormData();

      headerFormDataL.append("F_SheetSizingMasterH", res?.data?.id);
      headerFormDataL.append("Data", JSON.stringify(validRows));

      const res2 = await Fn_AddEditData(
        this.obj,
        {
          arguList: { id: 0, formData: headerFormDataL },
        },
        this.API_URL_SAVE,
        this.pushFormName,
        true
      );

      const res3 = await Fn_FillListData(
        this.obj,
        "VoucherNo",
        API_WEB_URLS.MASTER + "/0/token/VoucherNo/Id/0"
      );

      this.setState({ voucherNo: res?.data?.id });
    } catch (err) {
      console.error("Save failed:", err);
    }
  };

  CalcWidth = row => {
    // Get width increment and length increment
    const hIncre = parseFloat(row.HeightX || 0);
    const lIncre = parseFloat(row.LengthX || 0);

    // Calculate equal to box
    const equaltobox = (hIncre * lIncre).toFixed(1);

    // Calculate new width
    const width = parseFloat(row.Width || 0);
    width = (width * hIncre).toFixed(2);

    // Calculate sheet quantity
    const box = parseFloat(row.NoOfBox || 0);
    var sheet = 0;
    sheet = (box / equaltobox).toFixed(2);
    sheet = sheet > 0 ? parseInt(sheet) : 0;

    // Return updated values
    return {
      ...row,
      Width: width,
      EqualtoBox: equaltobox,
      SheetQty: sheet,
    };
  };

  CalcLength = row => {
    // Get width increment and length increment
    const wIncre = parseFloat(row.W || 0);
    const lIncre = parseFloat(row.L || 0);

    // Calculate equal to box
    const equaltobox = (lIncre * wIncre).toFixed(1);

    // Calculate new length
    const length = parseFloat(row.Length || 0);
    length = (length * lIncre).toFixed(2);

    // Calculate sheet quantity
    const box = parseFloat(row.NoOfBox || 0);
    var sheet = 0;
    sheet = (box / equaltobox).toFixed(2);
    sheet = sheet > 0 ? parseInt(sheet) : 0;

    // Return updated values
    return {
      ...row,
      Length: length,
      EqualtoBox: equaltobox,
      SheetQty: sheet,
    };
  };

  handlePrint = async () => {
    // const selectedRow = this.state.sheetRows[this.state.selectedRowIndex];
    // const selectedId = selectedRow?.F_SheetSizingMasterL || 0;

    // Get the selected voucher ID from the dropdown
    const selectedId = this.state.voucherNo || 0;

    console.log("Selected Voucher ID:", selectedId);

    await Fn_FillListData(
      this.obj,
      "JobCard_SheetSizing",
      `${API_WEB_URLS.MASTER}/0/token/JobCard_SheetSizing/Id/${selectedId}`
    );

    let formData = new FormData();
    // Pass the selected voucher ID to GetJobcard_Sheetsizing
    formData.append("Id", selectedId);

    // Call GetJobcard_Sheetsizing with the selected voucher ID
    await Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: formData } },
      "GetJobcard_Sheetsizing/0/token",
      "SheetSizingData",
      true
    );

    sessionStorage.setItem(
      "SheetSizingData",
      JSON.stringify({
        JobCard_SheetSizing: this.state.JobCard_SheetSizing || [],
        SheetSizingData: this.state.SheetSizingData || [],
      })
    );

    // Open in new tab
    if (API_WEB_URLS.Customer == 7|| API_WEB_URLS.Customer == 13 || API_WEB_URLS.Customer == 11) {
      window.open("/SheetPrintForCreative", "_blank");
    } else if (API_WEB_URLS.Customer == 2) {
      window.open("/SheetPrintForshreenath", "_blank");
    } else {
      window.open("/SheetPrintView", "_blank");
    }
  };

  SetSheetQty = row => {
    // Get box quantity
    const box =
      !row.NoOfBox || row.NoOfBox == "0" ? 0 : parseFloat(row.NoOfBox);

    // Get calculation type
    const calcType = row.F_CalculationTypeMaster;

    // Special cases for Ccap and Half Box WOF
    if (calcType == 12) {
      return {
        ...row,
        SheetQty: box,
      };
    }

    // Get increments and DP/SP value
    const LengthIncre =
      !row.LengthIncre || row.LengthIncre == "0"
        ? 0
        : parseFloat(row.LengthIncre);
    const HeightIncre =
      !row.HeightIncre || row.HeightIncre == "0"
        ? 0
        : parseFloat(row.HeightIncre);

    let sheetQty = 0;

    // Calculate sheet quantity based on increments
    if (LengthIncre > 0 && HeightIncre > 0) {
      sheetQty = box / (LengthIncre * HeightIncre);

      // Adjust based on DP/SP value
      if (row.SPDP == "1" || row.SPDP == 1) {
        sheetQty = sheetQty * 2;
      } else if (row.SPDP == "3" || row.SPDP == 3) {
        sheetQty = sheetQty * 2;
      }
    }

    return {
      ...row,
      SheetQty: sheetQty,
    };
  };

  render() {
    const {
      showCalc,
      F_UnitSize,
      F_ItemTypeMaster,
      F_PrintDescriptionMaster,
      UnitSize,
      F_VoucherNo,
      voucherDate,
      VoucherNo,
      LedgerMaster,
      F_LedgerMaster,
      UnitName,
      DOD,
      TypeMaster,
      F_TypeMaster,
      Ply,
      F_PlyMaster,
      PrintDescription,
      PaperTypeMaster,
      F_PaperTypeMaster,
      CalculationTypeMaster,
      F_CalculationType,
      SootMaster,
      F_SootMaster,
      ItemTypeMaster,
      F_ItemType,
      description,
      selectedRowIndex,
      sheetRows,
      TotalQty,
      OrderArr,
    } = this.state;

    return (
      <div className="page-content">
        <style>
          {`
          .label { font-weight: bold; margin-bottom: 4px; display: block; color: #333; }
          .form-section { margin-bottom: 20px; }
          .textarea-resize { resize: vertical; }
          .section-heading {
            color: #6B21A8;
            font-weight: 700;
            font-size: 1.3rem;
            text-align: center;
            margin-bottom: 1.5rem;
          }
          .table-wrapper { overflow-x: auto; }
          .action-buttons { display: flex; justify-content: space-between; margin-top: 20px; }
          .action-buttons .left, .action-buttons .right { display: flex; gap: 10px; }
        `}
        </style>

        <Container fluid className="p-4">
          <Row className="form-section">
            <Col md={3}>
              <label className="label">Select Voucher No.</label>
              <select
                name="VoucherNo"
                value={this.state.voucherNo}
                onChange={this.handleChangeVoucherNo}
                style={{
                  width: "100%",
                  padding: "4px",
                  borderRadius: "2px",
                  border: "1px solid #ddd",
                  backgroundColor: "white",
                }}
              >
                <option value="">Select Voucher</option>
                {Array.isArray(VoucherNo) &&
                  VoucherNo.map(option => (
                    <option key={option.Id} value={option.Id}>
                      {`${option.VNo}          ${option.Name}             ${option.Date}`}
                    </option>
                  ))}
              </select>
            </Col>
            <Col md={3}>
              <label className="label">Select Order No.</label>
              <select
                name="OrderId"
                value={this.state.OrderId}
                onChange={this.handleChangeOrderNo}
                style={{
                  width: "100%",
                  padding: "4px",
                  borderRadius: "2px",
                  border: "1px solid #ddd",
                  backgroundColor: "white",
                }}
              >
                <option value="">Select Order</option>
                {OrderArr &&
                  OrderArr &&
                  Array.isArray(OrderArr) &&
                  OrderArr.map(option => (
                    <option key={option.Id} value={option.Id}>
                      {option.Name}
                    </option>
                  ))}
              </select>
            </Col>
          </Row>

          <div className="section-heading">INNOVATION SHEET SIZING</div>

          <Row className="form-section">
            <Col md={2}>
              <label className="label">Voucher No.</label>
              <input
                ref={this.voucherNoRef}
                type="text"
                value={
                  this.state.SheetSizingDetail.length > 0
                    ? this.state.SheetSizingDetail[0].F_VoucherNo
                    : F_VoucherNo
                }
                onChange={e => this.setState({ F_VoucherNo: e.target.value })}
                onKeyDown={e => this.handleKeyDown(e, "voucherNo")}
                style={{
                  width: "100%",
                  padding: "4px",
                  borderRadius: "2px",
                  border: "1px solid #ddd",
                  backgroundColor: "white",
                }}
              />
            </Col>
            <Col md={2}>
              <label className="label">Voucher Date</label>
              <input
                ref={this.voucherDateRef}
                type="date"
                value={
                  this.state.SheetSizingDetail.length > 0
                    ? this.state.SheetSizingDetail[0].voucherDate
                    : voucherDate
                }
                onChange={e => this.setState({ voucherDate: e.target.value })}
                onKeyDown={e => this.handleKeyDown(e, "voucherDate")}
                style={{
                  width: "100%",
                  padding: "4px",
                  borderRadius: "2px",
                  border: "1px solid #ddd",
                  backgroundColor: "white",
                }}
              />
            </Col>

            <Col md={4}>
              <label className="label">Ledger Name</label>
              <select
                ref={this.ledgerRef}
                name="F_LedgerMaster"
                value={
                  this.state.SheetSizingDetail.length > 0
                    ? this.state.SheetSizingDetail[0].F_LedgerMaster
                    : F_LedgerMaster
                }
                onChange={this.handleChange}
                onKeyDown={e => this.handleKeyDown(e, "ledger")}
                style={{
                  width: "100%",
                  padding: "4px",
                  borderRadius: "2px",
                  border: "1px solid #ddd",
                  backgroundColor: "white",
                }}
              >
                <option value="">Select Ledger</option>
                {LedgerMaster &&
                  LedgerMaster.map(option => (
                    <option key={option.Id} value={option.Id}>
                      {option.Name}
                    </option>
                  ))}
              </select>
            </Col>
            <Col md={2}>
              <label className="label">Order No.</label>
              <input
                ref={this.orderNoRef}
                type="text"
                name="OrderNo"
                value={
                  this.state.SheetSizingDetail.length > 0
                    ? this.state.SheetSizingDetail[0].OrderNo
                    : this.state.OrderNo
                }
                onChange={e => this.setState({ OrderNo: e.target.value })}
                onKeyDown={e => this.handleKeyDown(e, "orderNo")}
                style={{
                  width: "100%",
                  padding: "4px",
                  borderRadius: "2px",
                  border: "1px solid #ddd",
                  backgroundColor: "white",
                }}
              />
            </Col>
          </Row>

          <Row className="form-section">
            <Col md={4}>
              <label className="label">DOD</label>
              <input
                ref={this.dodRef}
                type="date"
                name="DOD"
                value={
                  this.state.SheetSizingDetail.length > 0
                    ? this.state.SheetSizingDetail[0].DOD
                    : this.state.DOD
                }
                onChange={this.handleChange}
                onKeyDown={e => this.handleKeyDown(e, "dod")}
                style={{
                  width: "100%",
                  padding: "4px",
                  borderRadius: "2px",
                  border: "1px solid #ddd",
                  backgroundColor: "white",
                }}
              />
            </Col>

            <Col md={4}>
              <label className="label">Order Date </label>
              <input
                ref={this.orderDateRef}
                type="date"
                name="OrderDate2"
                value={
                  this.state.SheetSizingDetail.length > 0
                    ? this.state.SheetSizingDetail[0].OrderDate2
                    : this.state.OrderDate2
                }
                onChange={this.handleChange}
                onKeyDown={e => this.handleKeyDown(e, "orderDate")}
                style={{
                  width: "100%",
                  padding: "4px",
                  borderRadius: "2px",
                  border: "1px solid #ddd",
                  backgroundColor: "white",
                }}
              />
            </Col>
            <Col md={4}>
              <label className="label">Unit Name</label>
              <input
                ref={this.unitNameRef}
                type="text"
                name="UnitName"
                value={
                  this.state.SheetSizingDetail.length > 0
                    ? this.state.SheetSizingDetail[0].UnitName
                    : UnitName
                }
                onChange={this.handleChange}
                onKeyDown={e => this.handleKeyDown(e, "unitName")}
                style={{
                  width: "100%",
                  padding: "4px",
                  borderRadius: "2px",
                  border: "1px solid #ddd",
                  backgroundColor: "white",
                }}
              />
            </Col>
          </Row>

          <SheetSizingGrid
            sheetRows={sheetRows}
            selectedRowIndex={selectedRowIndex}
            handleInputChange={this.handleInputChange}
            handleAddRow={this.handleAddRow}
            handleDeleteRow={this.handleDeleteRow}
            handleRowClick={i => this.setState({ selectedRowIndex: i })}
            UnitSize={UnitSize}
            ItemTypeMaster={ItemTypeMaster}
            Ply={Ply}
            TypeMaster={TypeMaster}
            CalculationTypeMaster={CalculationTypeMaster}
            PrintDescription={PrintDescription}
            ConverttoSoot={this.ConverttoSoot}
            IsManualEntry={this.state?.GlobalOptions && this.state?.GlobalOptions[0]?.IsManualEntry}
            ref={this.sheetSizingGridRef}
          />

          <div className="d-flex justify-content-end align-items-center mt-4 gap-2">
            <strong>Total Qty:</strong>
            <input
              type="number"
              style={{
                width: "150px",
                padding: "4px",
                borderRadius: "2px",
                border: "1px solid #ddd",
                backgroundColor: "#f8f9fa",
              }}
              value={
                this.state.SheetSizingDetail.length > 0
                  ? this.state.SheetSizingDetail[0].TotalQty
                  : TotalQty
              }
              readOnly
            />
          </div>

          <div className="action-buttons">
            <div className="left">
              <Button color="success" onClick={this.handleAdd}>
                Add
              </Button>

              <button
                type="submit"
                className="btn btn-primary waves-effect waves-light me-2"
                id="saveButton"
                onClick={this.btnSave_onClick}
                style={{
                  background: "linear-gradient(135deg, #007bff, #0056b3)",
                  border: "none",
                  borderRadius: "6px",
                  padding: "10px 20px",
                  fontWeight: "600",
                  fontSize: "14px",
                  boxShadow: "0 4px 8px rgba(0,123,255,0.3)",
                  transition: "all 0.3s ease",
                  transform: "translateY(0)",
                }}
                onMouseEnter={e => {
                  e.target.style.background =
                    "linear-gradient(135deg, #0056b3, #004085)";
                  e.target.style.boxShadow = "0 6px 12px rgba(0,123,255,0.4)";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={e => {
                  e.target.style.background =
                    "linear-gradient(135deg, #007bff, #0056b3)";
                  e.target.style.boxShadow = "0 4px 8px rgba(0,123,255,0.3)";
                  e.target.style.transform = "translateY(0)";
                }}
                onFocus={e => {
                  e.target.style.background =
                    "linear-gradient(135deg, #28a745, #20c997)";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(40,167,69,0.25), 0 6px 12px rgba(0,123,255,0.4)";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.outline = "none";
                }}
                onBlur={e => {
                  e.target.style.background =
                    "linear-gradient(135deg, #007bff, #0056b3)";
                  e.target.style.boxShadow = "0 4px 8px rgba(0,123,255,0.3)";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                Save
              </button>

              <Button
                color="danger"
                disabled={!this.state.voucherNo}
                onClick={this.delete}
              >
                Delete
              </Button>
              <Button
                color="dark"
                onClick={this.handlePrint}
                // disabled={
                //   this.state.selectedRowIndex === null ||
                //   this.state.selectedRowIndex === undefined
                // }
              >
                Print
              </Button>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default compose(container)(AddSheetSizing);
